import
{
    CLEAR_AD_REQUEST,
    CONFIGURE_ADS_FULFILLED,
    CONFIGURE_ADS_PENDING,
    CONFIGURE_ADS_REJECTED,
    CONFIGURE_PAGE_AD_SLOTS_FULFILLED,
    CONFIGURE_PAGE_AD_SLOTS_PENDING,
    GET_AD_CONFIG_FULFILLED,
    GET_AD_CONFIG_PENDING,
    GET_AD_CONFIG_REJECTED,
    GET_DISPLAY_AD_FOR_SLOT,
    GET_DISPLAY_AD_FOR_SLOT_FULFILLED,
    GET_DISPLAY_AD_FOR_SLOT_REJECTED,
    REGISTER_DISPLAY_AD,
    REGISTER_DISPLAY_AD_FULFILLED,
    REGISTER_DISPLAY_AD_REJECTED,
    RENDER_DISPLAY_AD_FOR_SLOT,
    RENDER_DISPLAY_AD_FOR_SLOT_FULFILLED,
    RENDER_DISPLAY_AD_FOR_SLOT_REJECTED
} from '../actions/displayAdActions.js';

const initialState = {
    adConfigIsFetching: false,
    pageAdsConfigured: false,
    adsConfigured: false
};

export function displayAd(state = initialState, action)
{
    switch (action.type)
    {
        case GET_AD_CONFIG_PENDING:
        {
            return {
                ...state,
                adConfigIsFetching: true
            };
        }
        case GET_AD_CONFIG_FULFILLED:
        {
            return {
                ...state,
                adConfig: action.payload,
                adConfigIsFetching: false
            };
        }
        case GET_AD_CONFIG_REJECTED:
        {
            return {
                ...state,
                adConfigLoadError: action.payload,
                adConfigIsFetching: false
            };
        }
        case CLEAR_AD_REQUEST:
        {
            return {
                ...state,
                adConfig: null,
                pageAdsConfigured: false
            };
        }
        case CONFIGURE_ADS_PENDING:
        {
            return {
                ...state,
                adsConfigured: false
            };
        }
        case CONFIGURE_ADS_FULFILLED:
        {
            return {
                ...state,
                adsConfigured: true
            };
        }
        case CONFIGURE_PAGE_AD_SLOTS_PENDING:
        {
            return {
                ...state,
                pageAdsConfigured: false
            };
        }
        case CONFIGURE_PAGE_AD_SLOTS_FULFILLED:
        {
            return {
                ...state,
                pageAdsConfigured: true,
                currentConfiguredPageId: action.payload.pageId,
                currentConfiguredLatitude: action.payload.latitude,
                currentConfiguredLongitude: action.payload.longitude
            };
        }
        case GET_DISPLAY_AD_FOR_SLOT:
        {
            return {
                ...state,
                isFetching: true
            };
        }

        case GET_DISPLAY_AD_FOR_SLOT_FULFILLED:
        {
            return {
                ...state,
                displayAds: action.payload,
                lastError: {},
                isFetching: false
            };
        }

        case GET_DISPLAY_AD_FOR_SLOT_REJECTED:
        {
            return {
                ...state,
                displayAds: undefined,
                lastError: action.payload,
                isFetching: false
            };
        }

        case REGISTER_DISPLAY_AD:
        {
            return {
                ...state,
                isFetching: true
            };
        }

        case REGISTER_DISPLAY_AD_FULFILLED:
        {
            return {
                ...state,
                displayAds: action.payload,
                lastError: {},
                isFetching: false
            };
        }

        case REGISTER_DISPLAY_AD_REJECTED:
        {
            return {
                ...state,
                displayAds: undefined,
                lastError: action.payload,
                isFetching: false
            };
        }

        case RENDER_DISPLAY_AD_FOR_SLOT:
        {
            return {
                ...state,
                isFetching: true
            };
        }

        case RENDER_DISPLAY_AD_FOR_SLOT_FULFILLED:
        {
            return {
                ...state,
                displayAds: action.payload,
                lastError: {},
                isFetching: false
            };
        }

        case RENDER_DISPLAY_AD_FOR_SLOT_REJECTED:
        {
            return {
                ...state,
                displayAds: undefined,
                lastError: action.payload,
                isFetching: false
            };
        }

        default:
        {
            return state;
        }
    }
}
